export default "__VITE_ASSET__c5f6c1fb__"